/**
 * @generated SignedSource<<eaae26d962ede613c401b66399f1a4f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UploadWorkOrderPdfQuery$variables = {
  id: string;
};
export type UploadWorkOrderPdfQuery$data = {
  readonly getLocation: {
    readonly id: string;
    readonly name: string;
    readonly uuid: string | null;
    readonly workOrderPdf: string | null;
  };
};
export type UploadWorkOrderPdfQuery = {
  response: UploadWorkOrderPdfQuery$data;
  variables: UploadWorkOrderPdfQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "LocationObjectType",
    "kind": "LinkedField",
    "name": "getLocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workOrderPdf",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadWorkOrderPdfQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadWorkOrderPdfQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d4a1059c9f02f7bb3aa71920790c4030",
    "id": null,
    "metadata": {},
    "name": "UploadWorkOrderPdfQuery",
    "operationKind": "query",
    "text": "query UploadWorkOrderPdfQuery(\n  $id: String!\n) {\n  getLocation(id: $id) {\n    id\n    uuid\n    name\n    workOrderPdf\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f6d6b9654cf9ff810d614e95b87ca1d";

export default node;
